import { render, staticRenderFns } from "./SharedWithMe.vue?vue&type=template&id=516c0644"
import script from "./SharedWithMe.vue?vue&type=script&lang=js"
export * from "./SharedWithMe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports